var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78301 5.43544L14.1104 1.88947L10.5644 13.2169L8.51729 8.64961C8.50896 8.62949 8.50015 8.60961 8.4911 8.58985L10.2061 6.87496L9.17669 5.84556L7.48002 7.54211C7.43752 7.5208 7.39431 7.50092 7.35014 7.48247L2.78301 5.43544ZM15.0378 0.0396284C15.6087 -0.153342 16.1533 0.391288 15.9604 0.962238L11.328 15.5052C11.1135 16.1402 10.2271 16.1722 9.96732 15.5541L7.1753 9.21383C7.10149 9.03824 6.96185 8.89859 6.78624 8.82478L0.445974 6.03276C-0.172116 5.773 -0.140206 4.88658 0.494904 4.67206L15.0378 0.0396284Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.930176 14.0639L4.70405 10.29L5.73344 11.3194L1.95957 15.0933L0.930176 14.0639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07365 8.91992L0.930176 10.0635L1.95957 11.0929L3.10313 9.94931L2.07365 8.91992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPending);
export default __webpack_public_path__ + "static/media/map-pending.9acdacf7baa5dbc47d14ccc83fea6df2.svg";
export { ForwardRef as ReactComponent };